<script setup lang="ts">
import { useSelectRegarding } from '../../../model/additional-info/support/info-customer-request/select-regarding.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectRegarding from './info-customer-request/SelectRegarding.vue'

defineOptions({
  name: 'InfoCustomerRequest',
})

const { isRequired } = useSelectRegarding()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Regarding"
      :required="isRequired"
    >
      <SelectRegarding />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
